import { ApiError } from '@/utils/fetch.client';

/** A calendar day, e.g. "Mar 4, 2026"; `—` when there is none. */
export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** Compact age for a right-aligned column: "42s ago", "3h ago", "2mo ago". */
export function formatAge(iso: string): string {
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}

/** Pulls the actionable text out of an API failure. */
export function errorText(err: unknown, fallback: string): string {
  // `AppError::BadRequest` renders its message as "Invalid request" and puts the
  // real cause in `details` — which is exactly the part an admin needs to see.
  if (err instanceof ApiError) return err.details ?? err.message;
  return err instanceof Error ? err.message : fallback;
}
